// Words for the games, levels B1 and B2.
// Each word is written once in all five languages, in this order: English, Italian, Spanish, French, Portuguese (Brazil).

export const GAME_WORDS_B = {
    B1: [
        ['journey', 'viaggio', 'viaje', 'voyage', 'viagem'],
        ['market', 'mercato', 'mercado', 'marché', 'mercado'],
        ['restaurant', 'ristorante', 'restaurante', 'restaurant', 'restaurante'],
        ['church', 'chiesa', 'iglesia', 'église', 'igreja'],
        ['museum', 'museo', 'museo', 'musée', 'museu'],
        ['station', 'stazione', 'estación', 'gare', 'estação'],
        ['airport', 'aeroporto', 'aeropuerto', 'aéroport', 'aeroporto'],
        ['opinion', 'opinione', 'opinión', 'opinion', 'opinião'],
        ['experience', 'esperienza', 'experiencia', 'expérience', 'experiência'],
        ['decision', 'decisione', 'decisión', 'décision', 'decisão'],
        ['problem', 'problema', 'problema', 'problème', 'problema'],
        ['square', 'piazza', 'plaza', 'place', 'praça'],
        ['palace', 'palazzo', 'palacio', 'palais', 'palácio'],
        ['health', 'salute', 'salud', 'santé', 'saúde'],
        ['neighbor', 'vicino', 'vecino', 'voisin', 'vizinho'],
        ['language', 'lingua', 'idioma', 'langue', 'língua'],
        ['newspaper', 'giornale', 'periódico', 'journal', 'jornal'],
        ['meeting', 'riunione', 'reunión', 'réunion', 'reunião'],
        ['luggage', 'bagaglio', 'equipaje', 'bagage', 'bagagem'],
        ['dream', 'sogno', 'sueño', 'rêve', 'sonho'],
        ['salary', 'stipendio', 'sueldo', 'salaire', 'salário'],
        ['habit', 'abitudine', 'hábito', 'habitude', 'hábito'],
        ['result', 'risultato', 'resultado', 'résultat', 'resultado'],
        ['choice', 'scelta', 'elección', 'choix', 'escolha'],
        ['promise', 'promessa', 'promesa', 'promesse', 'promessa'],
    ],
    B2: [
        ['culture', 'cultura', 'cultura', 'culture', 'cultura'],
        ['society', 'società', 'sociedad', 'société', 'sociedade'],
        ['government', 'governo', 'gobierno', 'gouvernement', 'governo'],
        ['economy', 'economia', 'economía', 'économie', 'economia'],
        ['technology', 'tecnologia', 'tecnología', 'technologie', 'tecnologia'],
        ['justice', 'giustizia', 'justicia', 'justice', 'justiça'],
        ['freedom', 'libertà', 'libertad', 'liberté', 'liberdade'],
        ['tradition', 'tradizione', 'tradición', 'tradition', 'tradição'],
        ['science', 'scienza', 'ciencia', 'science', 'ciência'],
        ['politics', 'politica', 'política', 'politique', 'política'],
        ['law', 'legge', 'ley', 'loi', 'lei'],
        ['history', 'storia', 'historia', 'histoire', 'história'],
        ['education', 'educazione', 'educación', 'éducation', 'educação'],
        ['research', 'ricerca', 'investigación', 'recherche', 'pesquisa'],
        ['development', 'sviluppo', 'desarrollo', 'développement', 'desenvolvimento'],
        ['responsibility', 'responsabilità', 'responsabilidad', 'responsabilité', 'responsabilidade'],
        ['knowledge', 'conoscenza', 'conocimiento', 'connaissance', 'conhecimento'],
        ['growth', 'crescita', 'crecimiento', 'croissance', 'crescimento'],
        ['power', 'potere', 'poder', 'pouvoir', 'poder'],
        ['peace', 'pace', 'paz', 'paix', 'paz'],
    ],
};